import { useStoreMap } from 'effector-react'
import type React from 'react'

import { useI18n } from '@/shared/lib/i18n'
import { Checkbox } from '@/shared/ui'

import * as model from './model'

type AgreeTermsCheckboxFieldProps = {
    name: string
}

export function AgreeTermsCheckboxField(props: React.PropsWithChildren<AgreeTermsCheckboxFieldProps>) {
    const { i18n } = useI18n()

    const checked = useStoreMap({
        store: model.$form,
        keys: [props.name],
        fn: (values) => values[props.name] ?? false,
    })

    const checkboxChanged = model.fieldUpdated.prepend((isSelected: boolean) => ({
        key: props.name,
        value: isSelected ? 'true' : '',
    }))

    return (
        <Checkbox
            onChange={checkboxChanged}
            isSelected={Boolean(checked)}
            checkboxLayout="auth-card"
            isRequired
            requiredErrorMessage={i18n.TEXT_ERROR_TERMS_REQUIRED}
        >
            {props.children}
        </Checkbox>
    )
}
